module.exports = __webpack_public_path__ + "static/mask_lo_067-a3b1d17d0b1aeaab6eb8d1329f159f26.jpg";